import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sizeRunSelect", "inventoryContainer", "sizesTable", "controlButton"]

  connect() {
    // Ocultar el contenedor inicialmente
    this.inventoryContainerTarget.style.display = "none"
  }

  async generateSizes(event) {
    const sizeRunId = event.target.value
    
    if (!sizeRunId) {
      this.sizesTableTarget.innerHTML = ""
      this.inventoryContainerTarget.style.display = "none"
      return
    }

    try {
      const response = await fetch(`/admin/corridas/${sizeRunId}/sizes`)
      const data = await response.json()
      
      this.renderSizesTable(data.sizes)
      this.inventoryContainerTarget.style.display = "block"
    } catch (error) {
      console.error("Error al cargar las tallas:", error)
    }
  }

  renderSizesTable(sizes) {
    const rows = sizes.map((size, index) => `
      <tr>
        <td>${size}</td>
        <td>
          <div class="input-with-controls">
            <button type="button" 
                    data-action="click->inventory-generator#decrementValue" 
                    data-index="${index}" 
                    data-field="quantity" 
                    class="btn-increment">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/>
              </svg>
            </button>
            <input type="number" 
                   name="product[inventories_attributes][${index}][quantity]" 
                   value="0" 
                   min="0"
                   class="form-control form-control-sm"
                   data-inventory-generator-target="stockInput"
                   data-index="${index}"
                   placeholder="0">
            <button type="button" 
                    data-action="click->inventory-generator#incrementValue" 
                    data-index="${index}" 
                    data-field="quantity" 
                    class="btn-increment">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5v14"/>
              </svg>
            </button>
            <input type="hidden" 
                   name="product[inventories_attributes][${index}][size]" 
                   value="${size}">
          </div>
        </td>
        <td>
          <div class="input-with-controls">
            <button type="button" 
                    data-action="click->inventory-generator#decrementValue" 
                    data-index="${index}" 
                    data-field="minimum_stock" 
                    class="btn-increment">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/>
              </svg>
            </button>
            <input type="number" 
                   name="product[inventories_attributes][${index}][minimum_stock]" 
                   value="0" 
                   min="0"
                   class="form-control form-control-sm"
                   data-inventory-generator-target="minimumInput"
                   data-index="${index}"
                   placeholder="0">
            <button type="button" 
                    data-action="click->inventory-generator#incrementValue" 
                    data-index="${index}" 
                    data-field="minimum_stock" 
                    class="btn-increment">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5v14"/>
              </svg>
            </button>
          </div>
        </td>
      </tr>
    `).join("")

    this.sizesTableTarget.innerHTML = rows
  }

  incrementValue(event) {
    const button = event.currentTarget
    const index = button.dataset.index
    const field = button.dataset.field
    const input = this.sizesTableTarget.querySelector(`input[name="product[inventories_attributes][${index}][${field}]"]`)
    
    if (input) {
      const currentValue = parseInt(input.value) || 0
      input.value = currentValue + 1
    }
  }

  decrementValue(event) {
    const button = event.currentTarget
    const index = button.dataset.index
    const field = button.dataset.field
    const input = this.sizesTableTarget.querySelector(`input[name="product[inventories_attributes][${index}][${field}]"]`)
    
    if (input) {
      const currentValue = parseInt(input.value) || 0
      input.value = Math.max(0, currentValue - 1)
    }
  }

  incrementColumn(event) {
    const button = event.currentTarget
    const column = button.dataset.column
    const field = column === 'stock' ? 'quantity' : 'minimum_stock'
    
    const inputs = this.sizesTableTarget.querySelectorAll(`input[name*="[${field}]"]`)
    inputs.forEach(input => {
      const currentValue = parseInt(input.value) || 0
      input.value = currentValue + 1
    })
  }

  decrementColumn(event) {
    const button = event.currentTarget
    const column = button.dataset.column
    const field = column === 'stock' ? 'quantity' : 'minimum_stock'
    
    const inputs = this.sizesTableTarget.querySelectorAll(`input[name*="[${field}]"]`)
    inputs.forEach(input => {
      const currentValue = parseInt(input.value) || 0
      input.value = Math.max(0, currentValue - 1)
    })
  }
}
